// extracted by mini-css-extract-plugin
export default {"hover":"categorical__hover___mQ4hy","value":"categorical__value___wHOeo"};